import { render } from "./page-karir.vue?vue&type=template&id=e8f922e0&scoped=true"
import script from "./page-karir.vue?vue&type=script&lang=js"
export * from "./page-karir.vue?vue&type=script&lang=js"

import "./page-karir.vue?vue&type=style&index=0&id=e8f922e0&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8f922e0"]])

export default __exports__